import { authHeader, authToken } from '../_helpers';
import { settings } from '../settings';

export const userService = {
  login,
  logout,
  getAll,
  addNew
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };
  return fetch(`${settings.apiUrl}/login/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login erfolgreich wenn ein jwt token zurück kommt
      if (user.token) {
        // benutzerdetails im local storage speichern
        localStorage.setItem('user', JSON.stringify(user));
      }

      return user;
    });
}

function logout() {
  localStorage.removeItem('user');
}

function getAll(rows, page, sortby, descending) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  const r =
    '?items_per_page=' +
    rows +
    '&page=' +
    page +
    '&orderby=' +
    sortby +
    '&desc=' +
    descending;

  return fetch(`${settings.apiUrl}/users/` + r, requestOptions).then(
    handleResponse
  );
}

function addNew(name, password, email, admin) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Access-Token': authToken()
    },
    body: JSON.stringify({
      name: name,
      password: password,
      email: email,
      admin: admin
    })
  };

  console.log(requestOptions);
  return fetch(`${settings.apiUrl}/users/`, requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
